import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { ModelMenuRefreshEventsKeys } from '@src/slide/domain/ui-model/element-modeles/Interface/model-menu-refresh.interface';

export class TableRefreshMenu {
    public static caculateItemValues = (tableModel: ITableModel): void => {
        if (!tableModel) return;
        // 刷新menuManager中缓存的菜单相关属性
        tableModel.getMenuManager()?.event?.emit(ModelMenuRefreshEventsKeys.REFRESH_MENU_VALUES_VALUES, tableModel);
        // 刷新model各从属模块属性缓存
        tableModel.getBackgroundFill().refreshMergePropertyValCache(); // fill
    };
}
